module.exports = {"id":"228967","name":"Edu Machado","rating":"71","photo":"./data/images/photos/2/228967.png","club":{"name":"Boavista","logo":"./data/images/clubs/Boavista.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EduMachado0.json
// module id = 1183
// module chunks = 0